import { polymorphicFactory, Box, Spacer, Grid, GridColumn, Typography, DsmColor, omitText, Carousel, CarouselSlide } from '@kohler-dsm-library/kohler-core';
import { clsx } from 'clsx';
import React from 'react';
import classes from './FeatureCardsWithModalSlider.module.css.mjs';
import { FeatureCard } from './subcomponents/FeatureCard/FeatureCard.mjs';

const FeatureCardsWithModalSlider = polymorphicFactory(
  (props, ref) => {
    const { component = "section", mod = "white", heading, cards, topSpacer, bottomSpacer, className, ...rest } = props;
    return /* @__PURE__ */ React.createElement(
      Box,
      {
        component,
        className: clsx("kohler-feature-cards-with-modal-slider-root", classes.featureCardsWithModalSliderContainer, className),
        ref,
        mod,
        ...rest
      },
      topSpacer && /* @__PURE__ */ React.createElement(Spacer, { ...topSpacer }),
      /* @__PURE__ */ React.createElement(Grid, { className: classes.featureCardsWithModalSliderGrid }, heading && /* @__PURE__ */ React.createElement(GridColumn, { className: clsx(classes.featureCardsWithModalSliderContentContainer) }, /* @__PURE__ */ React.createElement(Typography, { component: heading.component || "h2", ...omitText(heading), size: "h2", textColor: DsmColor.ContentSecondary }, heading.text)), /* @__PURE__ */ React.createElement(GridColumn, { className: clsx(classes.videoCarouselSliderGrid) }, /* @__PURE__ */ React.createElement(
        Carousel,
        {
          withControls: true,
          includeGapInSize: false,
          slideSize: 0,
          slideGap: "20px",
          align: "start",
          loop: false,
          containScroll: "trimSnaps",
          hideControlOnDisabled: false,
          carouselControlProps: {
            isOnPhoto: false,
            variant: "slider"
          }
        },
        cards.map((card) => /* @__PURE__ */ React.createElement(CarouselSlide, { key: card.heading.text }, /* @__PURE__ */ React.createElement(FeatureCard, { ...card })))
      ))),
      bottomSpacer && /* @__PURE__ */ React.createElement(Spacer, { ...bottomSpacer })
    );
  }
);

export { FeatureCardsWithModalSlider };
